import React, { createContext, useContext, useState, useCallback } from 'react'

const ModalContext = createContext()

export const useModal = () => useContext(ModalContext)

export const ModalProvider = ({ children }) => {
  const [modalProps, setModalProps] = useState({ isOpen: false })

  const hideModal = useCallback(() => {
    setModalProps({ isOpen: false })
  }, [])

  const showModal = useCallback(props => {
    setModalProps(prev => ({ ...props, isOpen: true, hideModal: props.hideModal || hideModal }))
  }, [hideModal])

  return <ModalContext.Provider value={{ modalProps, showModal, hideModal }}>{children}</ModalContext.Provider>
}
